const requestSaveLibraryPermissions = async () => {
	return {
		granted: true,
	};
};
export default requestSaveLibraryPermissions;
